import SystemModal from "../Common/SystemModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import ajaxFuelTanks from "../../util/remote/ajaxFuelTanks";
const UpdateStationFuelPriceModal = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // Form fields
  const [stationID, setStationID] = useState(null);
  const [fuel_category_id, setFuelCategoryID] = useState(null);
  const [tank_code, setTankCode] = useState("");
  const [capacity, setCapacity] = useState("");
  // Lists
  const [stations_list, setStationsList] = useState([]);
  const [fuel_categories_list, setFuelCategoriesList] = useState([]);
  // Populate form when modal opens
  useEffect(() => {
    if (props.data) {
      const data = props.data;
      setStationID(data.station_id || "");
      setTankCode(data.Tank_code || "");
      setCapacity(data.capacity || "");
      setFuelCategoryID(data.fuel_id || null); // initial fuel ID
    }
  }, [props.data]);
  // Fetch stations
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: d.id,
          label: d.station_name,
        }));
      setStationsList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  // Fetch fuel categories
  const fetchFuelCategories = async () => {
    setLoading(true);
    // optional: pass station_id if API requires it
    const data = { station_id: props.data?.station_id || 0 };
    const response = await ajaxFuelCategories.list_fuel_categories(data);
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: d.id,
          label: d.fuel_category,
        }));
      setFuelCategoriesList(list);
      // Pre-select fuel category if modal already has data
      if (props.data?.fuel_id) {
        const current = list.find(
          (c) => c.value.toString() === props.data.fuel_id.toString()
        );
        if (current) setFuelCategoryID(current.value);
      }
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStations();
    fetchFuelCategories();
  }, []);
  // Validation
  const allRowsFilled = () =>
    stationID && fuel_category_id && tank_code && capacity;
  // Update handler
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const payload = {
      id: props.data.id,
      station_id: stationID,
      fuel_category_id: fuel_category_id,
      tank_code: tank_code,
      capacity: capacity,
    };
    setLoading(true);
    const response = await ajaxFuelTanks.update_fuel_Tanks(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func(); // refresh parent data
      setTimeout(() => closeModal(), 2000);
    } else {
      toast.error(response.message);
    }
  };
  // Footer buttons
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, controls.close)}
        disabled={loading || !allRowsFilled()}
      >
        {loading ? "Updating..." : "Update"}
      </button>
    </>
  );
  return (
    <SystemModal title="Update Fuel Price" size="md" footer={RenderFooter}>
      <Toaster />
      {loading && <Loader />}
      <div className="row">
        <div className="col-lg-12">
          <form onSubmit={(e) => handleUpdate(e, () => {})}>
            <div className="row mb-3">
              {/* Station */}
              <div className="col-md-12 mb-3">
                <label>
                  Select Station <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  options={stations_list}
                  value={stations_list.find(
                    (item) => item.value.toString() === stationID?.toString()
                  )}
                  onChange={(selected) => setStationID(selected.value)}
                  isDisabled={true} // cannot change station
                  placeholder="Select station"
                />
              </div>
              {/* Fuel Category */}
              <div className="col-md-12 mb-3">
                <label>
                  Select Fuel Category
                  <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  options={fuel_categories_list}
                  value={
                    fuel_categories_list.find(
                      (c) => c.value.toString() === fuel_category_id?.toString()
                    ) || null
                  }
                  onChange={(selected) => setFuelCategoryID(selected.value)}
                  placeholder="Select fuel category"
                />
              </div>
              {/* Tank Code */}
              <div className="col-md-12 mb-3">
                <label>
                  Fuel Tank Code <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  value={tank_code}
                  onChange={(e) => setTankCode(e.target.value)}
                  className="form-control"
                  placeholder="Enter tank code, e.g diesel001#"
                  required
                />
              </div>
              {/* Capacity */}
              <div className="col-md-12 mb-3">
                <label>
                  Fuel Tank Capacity (liters)
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="number"
                  value={capacity}
                  onChange={(e) => setCapacity(e.target.value)}
                  className="form-control"
                  placeholder="Enter capacity in liters"
                  required
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </SystemModal>
  );
};
export default UpdateStationFuelPriceModal;
